<template>
  <div>
    <conversations acc-type="Shop" />
  </div>
</template>

<script>
import Conversations from "@/components/shared/Conversations/index.vue";

export default {
  components: {
    Conversations
  },

  computed: {
    conversations() {
      return this.$store.state.conversations.listArr;
    }
  },
  methods: {
    conversation(id) {
      return this.$store.state.conversations.list[id];
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
